import { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { type UsersMediaPage, type UsersMediaSortBy } from '../models/engagement-users'
import { GetUsersMediaQuery } from '../../data/queries/get-users-media.query'
import { type UsersMediaPageEntity } from '../../data/entities/users.entity'

export interface GetUsersMediaParams {
  fromDate: string
  toDate: string
  fromPrevious: string
  toPrevious: string
  sortBy: UsersMediaSortBy
  sortOrder: 'asc' | 'desc'
  offset: number
  limit: number
  organization: string
}

export class GetUsersMediaInteractor {
  constructor(private readonly repository: GetInteractor<UsersMediaPageEntity>) {}

  public async execute(params: GetUsersMediaParams): Promise<UsersMediaPage> {
    return await this.repository.execute(
      new GetUsersMediaQuery(
        params.fromDate,
        params.toDate,
        params.fromPrevious,
        params.toPrevious,
        params.sortBy,
        params.sortOrder,
        params.offset,
        params.limit,
        params.organization
      )
    )
  }
}
